module.exports = function() {
  return new Worker(__webpack_public_path__ + "15db0637af241d20ffac.worker.js");
};